import api from "./base/API.js";

const resource = "Route";
export default {
	get() {
		return api.get(resource);
	},

	getRoute(id) {
		return api.get(resource + "/" + id);
	},
};
